// extracted by mini-css-extract-plugin
module.exports =  {"alert":"aiXkVsMeJLSBHbj18OzB","select":"pZmsChWTUhUajn3CTZlU"};